/**
 * @desc Yung-获取审批业务key
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.ApprovalBeforeRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/approval/getBusinessKey`, {
      method: "GET",

      data: body,
      ...options,
    }),
  );
}
